// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.P3jdllqnP09WWBdGbXn4{flex-direction:column;width:100%;display:flex}.P3jdllqnP09WWBdGbXn4 .ACeK5Tfduh4E85eyWzVa{padding:4px}.P3jdllqnP09WWBdGbXn4 .pLBDYj00q0QHJmtbGgfF{border-radius:4px;align-items:center;gap:4px;width:100%;padding:4px 6px;display:flex}.P3jdllqnP09WWBdGbXn4 .pLBDYj00q0QHJmtbGgfF:hover{background:var(--background-primary-inverted-disabled)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `P3jdllqnP09WWBdGbXn4`,
	"title": `ACeK5Tfduh4E85eyWzVa`,
	"button": `pLBDYj00q0QHJmtbGgfF`
};
export default ___CSS_LOADER_EXPORT___;
